/* ═══════════════════════════════════════════════════════
   PLUMBING CODE REFERENCE DATA
   DFU tables, drain/vent sizing, water supply sizing
   ═══════════════════════════════════════════════════════ */

// ── Combined Fixture Unit Table (DFU + WSFU) ──
export const fixtureUnitHeaders = ["Fixture", "DFU (UPC)", "DFU (IPC)", "Trap Size", "WSFU Cold", "WSFU Hot", "WSFU Total"];
export const fixtureUnitRows: (string | number)[][] = [
  ["Lavatory",              1,    1,   "1-1/4\"",  0.5,  0.5,  0.7],
  ["Bathtub / Shower",      2,    2,   "1-1/2\"",  1.0,  1.0,  1.4],
  ["Shower (private)",      2,    2,   "2\"",       1.0,  1.0,  1.4],
  ["Shower (public)",       2,    2,   "2\"",       2.0,  2.0,  2.8],
  ["Kitchen Sink (dom.)",   2,    2,   "1-1/2\"",  1.0,  1.0,  1.4],
  ["Kitchen Sink (comm.)",  2,    2,   "1-1/2\"",  1.6,  1.2,  2.2],
  ["Kitchen Sink w/ DW",    3,    2,   "1-1/2\"",  "—",  "—",  "—"],
  ["Dishwasher",            2,    2,   "1-1/2\"",  "—",  1.4,  1.4],
  ["Clothes Washer (dom.)", 3,    3,   "2\"",       1.0,  1.0,  1.4],
  ["Clothes Washer (com.)", 3,    3,   "2\"",       1.0,  1.0,  1.4],
  ["Floor Drain (2\")",     2,    2,   "2\"",       "—",  "—",  "—"],
  ["Floor Drain (3\")",     3,    3,   "3\"",       "—",  "—",  "—"],
  ["Urinal (flush valve)",  4,    4,   "2\"",       3.0,  "—",  3.0],
  ["Urinal (flush tank)",   2,    2,   "2\"",       1.5,  "—",  1.5],
  ["Water Closet (FV)",     4,    4,   "3\"",       5.0,  "—",  5.0],
  ["Water Closet (tank)",   3,    3,   "3\"",       2.5,  "—",  2.5],
  ["Bar Sink",              1,    1,   "1-1/4\"",  0.5,  0.5,  0.7],
  ["Laundry Tub",           2,    2,   "1-1/2\"",  1.0,  1.0,  1.4],
  ["Mop Sink",              3,    3,   "3\"",       "—",  "—",  "—"],
  ["Drinking Fountain",     0.5,  0.5, "1-1/4\"",  0.25, "—",  0.25],
  ["Hose Bibb",             3,    3,   "—",         2.5,  "—",  2.5],
  ["Service Sink",          3,    3,   "3\"",       1.5,  1.5,  2.0],
  ["Lavatory (public)",     1,    1,   "1-1/4\"",  1.5,  1.5,  2.0],
];

// ── Drain Pipe Sizing (based on DFU load & slope) ──
export const drainSizingHeaders = ["Pipe Size", "1/16\" slope", "1/8\" slope", "1/4\" slope", "1/2\" slope"];
export const drainSizingRows: (string | number)[][] = [
  ["1-1/4\"", "—", 1,   1,   1],
  ["1-1/2\"", "—", 3,   3,   3],
  ["2\"",     "—", 6,  12,  26],
  ["2-1/2\"", "—",12,  20,  31],
  ["3\"",     "—", 20,  36,  50],
  ["4\"",     "—",180, 216, 250],
  ["5\"",     "—",390, 480, 575],
  ["6\"",    700, 700, 840,1000],
  ["8\"",    1400,1400,1680,2000],
  ["10\"",   2500,2500,3000,3600],
  ["12\"",   3900,3900,4680,5600],
];

// ── Vent Pipe Sizing (max DFU by developed length) ──
export const ventSizingHeaders = ["Vent Size", "30 ft", "50 ft", "100 ft", "150 ft", "200 ft"];
export const ventSizingRows: (string | number)[][] = [
  ["1-1/4\"",  1,   1,   1,   1,  "—"],
  ["1-1/2\"",  8,   6,   4,   2,  "—"],
  ["2\"",     24,  18,  10,   8,   6],
  ["2-1/2\"", 48,  36,  24,  18,  12],
  ["3\"",     84,  72,  48,  36,  30],
  ["4\"",    256, 216, 168, 120,  96],
  ["5\"",    600, 480, 324, 264, 216],
  ["6\"",   1380,1020, 720, 600, 480],
];

// ── Water Supply Pipe Sizing (GPM demand by WSFU) ──
export const waterSupplyHeaders = ["Supply Pipe", "Max WSFU", "Est. GPM"];
export const waterSupplyRows: (string | number)[][] = [
  ["3/8\"",    1,    1],
  ["1/2\"",    4,    5],
  ["3/4\"",   14,   15],
  ["1\"",     30,   30],
  ["1-1/4\"", 60,   46],
  ["1-1/2\"",100,   67],
  ["2\"",    250,  130],
  ["2-1/2\"",450,  200],
  ["3\"",    750,  300],
  ["4\"",   1500,  500],
];

// ── Hunter's Curve data for WSFU → GPM conversion ──
export const HUNTERS_CURVE: { wsfu: number; gpm: number }[] = [
  { wsfu: 1, gpm: 3 },
  { wsfu: 2, gpm: 5 },
  { wsfu: 5, gpm: 8 },
  { wsfu: 10, gpm: 12 },
  { wsfu: 20, gpm: 18 },
  { wsfu: 40, gpm: 25 },
  { wsfu: 60, gpm: 33 },
  { wsfu: 80, gpm: 40 },
  { wsfu: 100, gpm: 46 },
  { wsfu: 150, gpm: 58 },
  { wsfu: 200, gpm: 67 },
  { wsfu: 300, gpm: 85 },
  { wsfu: 400, gpm: 105 },
  { wsfu: 500, gpm: 120 },
  { wsfu: 750, gpm: 170 },
  { wsfu: 1000, gpm: 210 },
  { wsfu: 1500, gpm: 280 },
  { wsfu: 2000, gpm: 340 },
  { wsfu: 3000, gpm: 440 },
];
